import React, { useState } from 'react'
import styles from './PanelButton.module.scss'
import classnames from 'classnames'
import { colour as colourEnum } from '../Icon/types'
import NotificationBadge from '../NotificationBadge'
import GrowingIcon from '../GrowingIcon'
import Props from './types'

const PanelButton: React.FC<Props> = props => {

  const {
    selected = false,
    colour = 'none'
  } = props

  const [ isHovering, setIsHovering ] = useState(false)

  const defaultColour = props.defaultColour && props.defaultColour ? props.defaultColour : ''

  const buttonClasses = classnames(styles['panelButton'], {
    [styles['panelButton--selected']]: selected,
    [styles[defaultColour]]: defaultColour,
    [styles[colour]]: defaultColour === '' && typeof colour !== 'undefined'
  })

  function getIconColour (): colourEnum {

    let colour = props.colour

    if (props.defaultColour) colour = props.defaultColour
    else {

      if (!selected) return colourEnum.secondary

    }

    return colour as colourEnum || colourEnum.secondary

  }

  const iconColour = getIconColour()

  return <button
    className={buttonClasses}
    type='button'
    onClick={props.onClick}
    data-bdd={props.dataBdd ? props.dataBdd : 'sidepanel-menu-item-button'}
    id={props.id}
    onMouseOver={() => setIsHovering(true)}
    onMouseOut={() => setIsHovering(false)}
  >
    <div className={styles['panelButton-layer-container']}>
      <GrowingIcon
        icon= {{
          name: props.icon,
          colour: iconColour
        }}
        selected={selected}
        hovered={isHovering}
      />
    </div>
    <div className={styles['panelButton-layer-container']}>
      <div className={styles['panelButton-border']} />
    </div>
    <div className={styles['panelButton-layer-container']}>
      <NotificationBadge { ...props.notifications } />
    </div>
  </button>

}

export default PanelButton
